import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@core/services';
import { redirectToAccessDenied } from '@shared/utilities';
import { Observable, of } from 'rxjs';
import { MainDashboardsService } from './services/main-dashboards.service';

@Injectable({ providedIn: 'root' })
export class DashboardAccessGuard implements CanActivate {
  authService = inject(AuthService);
  router = inject(Router);
  constructor(private readonly mainDashboardsService: MainDashboardsService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const userDataRaw = this.authService.currentUser();
    if (!userDataRaw) {
      redirectToAccessDenied(this.router);
      return of(false);
    }

    return new Observable<boolean | UrlTree>(observer => {
      this.mainDashboardsService.userDashboards.subscribe({
        next: dashboards => {
          const dashboardId =
            route.routeConfig?.path ??
            route.params['dashboardId'] ??
            route.queryParams['dashboardId'];
          if (!dashboardId && dashboards.length > 0) {
            observer.next(true);
          } else if (
            dashboardId &&
            dashboards.some(
              d =>
                String(d.dashboardId) === String(dashboardId) ||
                d.url?.includes(dashboardId),
            )
          ) {
            observer.next(true);
          } else {
            redirectToAccessDenied(this.router);
            observer.next(false);
          }
          observer.complete();
        },
        error: () => {
          redirectToAccessDenied(this.router);
          observer.next(false);
          observer.complete();
        },
      });
    });
  }
}
